import {
  createFrontendModule,
  NavItemBlueprint,
  createExtension,
  coreExtensionData,
} from '@backstage/frontend-plugin-api';
import { IconComponent } from '@backstage/core-plugin-api';
import { Search } from 'lucide-react';
import searchPlugin from '@backstage/plugin-search/alpha';
import { searchPage } from '../components/search/SearchPage';

// Create a custom search navigation item with better icon
// IMPORTANT: No 'name' property to ensure ID matches the original 'nav-item:search'
const customSearchNavItem = NavItemBlueprint.make({
  params: {
    title: 'Search',
    icon: Search as IconComponent,
    routeRef: searchPlugin.routes.root,
  },
});

// Apply override to replace the factory function
const customSearchNavExtension = customSearchNavItem.override({
  factory: (originalFactory, context) => {
    return originalFactory(context);
  },
});

// Custom search page content extension
const customSearchContentExtension = createExtension({
  name: 'custom-search-content',
  attachTo: { id: 'search-page', input: 'content' },
  output: [coreExtensionData.reactElement],
  factory: () => [
    coreExtensionData.reactElement(searchPage),
  ],
});

// Create a module that contains our custom search configurations
// Using 'search' as pluginId since we're overriding search plugin
export const customSearchModule = createFrontendModule({
  pluginId: 'search',
  extensions: [
    customSearchNavExtension, // Custom nav item with better icon
    customSearchContentExtension, // Custom search page content
    // Add more search customizations here later
  ],
});